import { __extends } from "tslib";
import { PutKeyPolicyRequest } from "../models/models_0";
import { deserializeAws_json1_1PutKeyPolicyCommand, serializeAws_json1_1PutKeyPolicyCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Attaches a key policy to the specified customer master key (CMK).
 *       You cannot perform this operation on a CMK in a different AWS account.</p>
 *          <p>For more information about key policies, see <a href="https://docs.aws.amazon.com/kms/latest/developerguide/key-policies.html">Key Policies</a> in the <i>AWS Key Management Service Developer Guide</i>.</p>
 */
var PutKeyPolicyCommand = /** @class */ (function (_super) {
    __extends(PutKeyPolicyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutKeyPolicyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutKeyPolicyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KMSClient";
        var commandName = "PutKeyPolicyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: PutKeyPolicyRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutKeyPolicyCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1PutKeyPolicyCommand(input, context);
    };
    PutKeyPolicyCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1PutKeyPolicyCommand(output, context);
    };
    return PutKeyPolicyCommand;
}($Command));
export { PutKeyPolicyCommand };
//# sourceMappingURL=PutKeyPolicyCommand.js.map